"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTS_ROLES = void 0;
var PRODUCTS_ROLES;
(function (PRODUCTS_ROLES) {
    PRODUCTS_ROLES["SEARCH_PRODUCTS"] = "search-products";
    PRODUCTS_ROLES["VIEW_PRODUCT"] = "view-product";
    PRODUCTS_ROLES["CREATE_PRODUCT"] = "create-product";
    PRODUCTS_ROLES["MODIFY_PRODUCT"] = "modify-product";
    PRODUCTS_ROLES["MODIFY_PRODUCT_BOM_COMPLETE"] = "modify-product-bom-complete";
    PRODUCTS_ROLES["SEARCH_BOM"] = "search-bom";
    PRODUCTS_ROLES["VIEW_BOM"] = "view-bom";
    PRODUCTS_ROLES["CREATE_BOM"] = "create-bom";
    PRODUCTS_ROLES["MODIFY_BOM"] = "modify-bom";
    PRODUCTS_ROLES["DELETE_BOM"] = "delete-bom";
    PRODUCTS_ROLES["CREATE_ESTIMATING_MANUFACTURING_INFO"] = "create-estimating-manufacturing-info";
    PRODUCTS_ROLES["MODIFY_ESTIMATING_MANUFACTURING_INFO"] = "modify-estimating-manufacturing-info";
    PRODUCTS_ROLES["CREATE_LOCATION_MANUFACTURING_INFO"] = "create-location-manufacturing-info";
    PRODUCTS_ROLES["VIEW_LOCATION_MANUFACTURING_INFO"] = "view-location-manufacturing-info";
    PRODUCTS_ROLES["MODIFY_LOCATION_MANUFACTURING_INFO"] = "modify-location-manufacturing-info";
    PRODUCTS_ROLES["DELETE_LOCATION_MANUFACTURING_INFO"] = "delete-location-manufacturing-info";
    PRODUCTS_ROLES["CREATE_PRODUCT_CLASS"] = "create-product-class";
    PRODUCTS_ROLES["VIEW_PRODUCT_CLASS"] = "view-product-class";
    PRODUCTS_ROLES["SEARCH_PRODUCT_CLASS"] = "search-product-class";
    PRODUCTS_ROLES["MODIFY_PRODUCT_CLASS"] = "modify-product-class";
    PRODUCTS_ROLES["MODIFY_PRODUCT_CROSS_REFERENCE"] = "modify-product-cross-reference";
    PRODUCTS_ROLES["CREATE_PRODUCT_MANUFACTURER"] = "create-product-manufacturer";
    PRODUCTS_ROLES["VIEW_PRODUCT_MANUFACTURER"] = "view-product-manufacturer";
    PRODUCTS_ROLES["SEARCH_PRODUCT_MANUFACTURERS"] = "search-product-manufacturers";
    PRODUCTS_ROLES["MODIFY_PRODUCT_MANUFACTURER"] = "modify-product-manufacturer";
    PRODUCTS_ROLES["CREATE_PRODUCT_PRICE_BREAK"] = "create-product-price-break";
    PRODUCTS_ROLES["VIEW_PRODUCT_PRICE_BREAK"] = "view-product-price-break";
    PRODUCTS_ROLES["MODIFY_PRODUCT_PRICE_BREAK"] = "modify-product-price-break";
    PRODUCTS_ROLES["DELETE_PRODUCT_PRICE_BREAK"] = "delete-product-price-break";
    PRODUCTS_ROLES["CREATE_PRODUCT_UM"] = "create-product-um";
    PRODUCTS_ROLES["MODIFY_PRODUCT_UM"] = "modify-product-um";
})(PRODUCTS_ROLES = exports.PRODUCTS_ROLES || (exports.PRODUCTS_ROLES = {}));
//# sourceMappingURL=products.roles.js.map